export const RESEND_EMAIL_TIMER_IN_SECONDS: number = 30

export const AUTOMATIC_REDIRECT_TIMER_IN_SECONDS: number = 5

export const DEFAULT_APP = 'dashboard'

export const ENTER_VALID_EMAIL_MESSAGE = 'Please enter a valid email address'
